import React, {useCallback, useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {readInputWindow} from "../dashboard/widgets/useRsoInputWindow";
import RsoInputWindowPanel from "../dashboard/widgets/RsoInputWindowPanel";
import RsoSwitchPanel from "../dashboard/widgets/RsoSwitchPanel";

// "RSO" on the Admin tab. Shown only when NANCY says this account may manage RSO
// (manage-rso-input-window, reported as canEdit: Admin and President); everyone else sees no button.
// Opens a pop-up with the one RSO on/off switch at the top and, while RSO is on, the input window
// (current month, open and close dates). While a save is running the pop-up can't be closed.
export default function RsoInputWindowButton({token}) {
  const [allowed, setAllowed] = useState(false);
  const [show, setShow] = useState(false);
  const [switchBusy, setSwitchBusy] = useState(false);
  const [windowBusy, setWindowBusy] = useState(false);
  const [rsoOn, setRsoOn] = useState(null);
  const busy = switchBusy || windowBusy;
  const onSwitchChanged = useCallback((value) => setRsoOn(value?.enabled === true), []);

  useEffect(() => {
    if (!token) return undefined;
    let current = true;
    readInputWindow(token)
      .then((value) => {if (current) setAllowed(value.canEdit);})
      .catch(() => {if (current) setAllowed(false);});
    return () => {current = false;};
  }, [token]);

  if (!allowed) return null;
  return <>
    <button type="button" className="btn btn-primary" onClick={() => setShow(true)}>RSO</button>
    <Modal show={show} onHide={() => {if (!busy) setShow(false);}} centered backdrop={busy ? "static" : true} keyboard={!busy}
      aria-labelledby="rso-input-window-title">
      <Modal.Header closeButton={!busy}>
        <Modal.Title id="rso-input-window-title">RSO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RsoSwitchPanel token={token} onBusyChange={setSwitchBusy} onChanged={onSwitchChanged} />
        {rsoOn !== false && <>
          <h6 className="rsw-divider">RSO input window</h6>
          <RsoInputWindowPanel token={token} onBusyChange={setWindowBusy} />
        </>}
      </Modal.Body>
    </Modal>
  </>;
}
